var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 5,
    viewBox: "0 0 10 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1955 4.7675L0.142 0.739C0.101166 0.698167 0.0672496 0.652 0.0402496 0.600501C0.0134163 0.549001 0 0.494417 0 0.436751C0 0.315584 0.0396661 0.212501 0.118999 0.127501C0.198333 0.0425009 0.301583 0 0.42875 0H8.86775C8.99492 0 9.09817 0.0436664 9.1775 0.131C9.25683 0.218166 9.2965 0.32125 9.2965 0.44025C9.2965 0.470083 9.24892 0.569917 9.15375 0.739751L5.10075 4.7675C5.04358 4.82483 4.976 4.87108 4.898 4.90625C4.82 4.94158 4.73658 4.95925 4.64775 4.95925C4.55892 4.95925 4.47567 4.94158 4.398 4.90625C4.32033 4.87108 4.25283 4.82483 4.1955 4.7675Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropIcon);
export default __webpack_public_path__ + "static/media/DropIcon.08cc92f0f7886b37a11d1ce84cb450b0.svg";
export { ForwardRef as ReactComponent };